 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP81838 from '@/components/chap81838'
 import CHAP80289 from '@/components/chap80289'
 import A1_CHAPTER01 from '@/components/01_chapter01'
 import A2_CHAPTER02 from '@/components/02_chapter02'
 import A3_CHAPTER03 from '@/components/03_chapter03'
 import A4_CHAPTER04 from '@/components/04_chapter04'
 import A5_CHAPTER05 from '@/components/05_chapter05'
 import A6_CHAPTER06 from '@/components/06_chapter06'
 import A7_CHAPTER07 from '@/components/07_chapter07'
 import LOVE_2 from '@/components/love_2'
 import AFTERWORD from '@/components/afterword'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import CHAP81837 from '@/components/chap81837'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap81838",
 			"name" : "chap81838",
 			"component" : CHAP81838
 		},
 		{
 			"path" : "/chap80289",
 			"name" : "chap80289",
 			"component" : CHAP80289
 		},
 		{
 			"path" : "/01_chapter01",
 			"name" : "01_chapter01",
 			"component" : A1_CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js